import React, { useState, useEffect, useCallback } from 'react';
import { api } from '../api';

function formatDuration(sec) {
  if (!sec || sec <= 0) return '0 мин';
  const h = Math.floor(sec / 3600);
  const m = Math.floor((sec % 3600) / 60);
  if (h > 0) return `${h}ч ${m}м`;
  return `${m} мин`;
}

function formatTokens(n) {
  if (!n) return '0';
  if (n >= 1000000) return (n / 1000000).toFixed(1) + 'M';
  if (n >= 1000) return (n / 1000).toFixed(1) + 'K';
  return n.toLocaleString();
}

function rfmColor(score) {
  if (score >= 4) return 'var(--success)';
  if (score >= 3) return '#f39c12';
  if (score >= 2) return '#e67e22';
  return 'var(--danger)';
}

function segmentBadge(segment) {
  const colors = {
    'Суперпользователь': { bg: 'rgba(0,184,148,0.2)', color: 'var(--success)' },
    'Активный': { bg: 'rgba(0,184,148,0.15)', color: '#00cec9' },
    'Умеренный': { bg: 'rgba(243,156,18,0.2)', color: '#f39c12' },
    'Низкая активность': { bg: 'rgba(230,126,34,0.2)', color: '#e67e22' },
    'Новичок': { bg: 'rgba(108,92,231,0.2)', color: '#a29bfe' },
    'Не использовал': { bg: 'rgba(231,76,60,0.2)', color: 'var(--danger)' },
  };
  const c = colors[segment] || colors['Новичок'];
  return <span style={{ padding: '4px 10px', borderRadius: 12, fontSize: '0.75rem', fontWeight: 600, background: c.bg, color: c.color }}>{segment}</span>;
}

function providerName(p) {
  if (p === 'openai') return 'ChatGPT';
  if (p === 'anthropic') return 'Claude';
  if (p === 'image') return 'Картинки';
  if (p === 'video') return 'Видео';
  return p;
}

function generateCSV(data) {
  const headers = ['Системное имя', 'Логин', 'Роль', 'Статус', 'Сообщений', 'Входные токены', 'Выходные токены', 'Всего токенов', 'Изображений', 'Видео', 'Секунд видео', 'Стоимость видео ($)', 'Стоимость ($)', 'Стоимость (₽)', 'RFM-R', 'RFM-F', 'RFM-M', 'Сегмент', 'Дней без активности', 'Активных дней'];
  const rows = data.users.map(u => [
    u.internal_name, u.display_login, u.role, u.active ? 'Активен' : 'Отключён',
    u.total_messages, u.total_input_tokens, u.total_output_tokens, u.total_tokens,
    u.image_count, u.video_count || 0, u.video_seconds || 0, u.video_cost_usd || 0,
    u.total_cost_usd, u.total_cost_rub,
    u.rfm.r, u.rfm.f, u.rfm.m, u.rfm.segment, u.rfm.days_since_last, u.rfm.active_days
  ]);
  const bom = '﻿';
  return bom + [headers.join(';'), ...rows.map(r => r.join(';'))].join('\n');
}

function downloadFile(content, filename, mime) {
  const blob = new Blob([content], { type: mime });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  a.click();
  URL.revokeObjectURL(url);
}

function exportXLS(data) {
  const csv = generateCSV(data);
  downloadFile(csv, `expomaster_analytics_${new Date().toISOString().slice(0, 10)}.csv`, 'text/csv;charset=utf-8');
}

function exportPDF(data) {
  const win = window.open('', '_blank');
  const date = new Date().toLocaleDateString('ru-RU');
  const html = `<!DOCTYPE html><html><head><meta charset="utf-8"><title>EXPOMASTER Analytics</title>
<style>
body{font-family:Arial,sans-serif;padding:24px;font-size:12px}
h1{font-size:18px;margin-bottom:4px}
h2{font-size:14px;margin-top:16px;margin-bottom:8px;color:#555}
table{width:100%;border-collapse:collapse;margin-bottom:16px}
th,td{border:1px solid #ddd;padding:6px 8px;text-align:left}
th{background:#f5f5f5;font-weight:600}
.total{font-weight:700;background:#fafafa}
.seg{padding:2px 8px;border-radius:8px;font-size:11px;font-weight:600}
@media print{body{padding:0}}
</style></head><body>
<h1>EXPOMASTER — Аналитический отчёт</h1>
<p>Дата: ${date} | Курс: 1 USD = ${data.totals.usd_rub_rate} ₽</p>
<h2>Общие показатели</h2>
<table><tr><th>Сообщений</th><th>Входные токены</th><th>Выходные токены</th><th>Изображений</th><th>Видео</th><th>Стоимость ($)</th><th>Стоимость (₽)</th></tr>
<tr class="total"><td>${data.totals.messages.toLocaleString()}</td><td>${data.totals.input_tokens.toLocaleString()}</td><td>${data.totals.output_tokens.toLocaleString()}</td><td>${data.totals.images}</td><td>${data.totals.videos || 0} (${data.totals.video_seconds || 0} сек)</td><td>$${data.totals.cost_usd}</td><td>${data.totals.cost_rub} ₽</td></tr></table>
<h2>По сотрудникам</h2>
<table><tr><th>Имя</th><th>Логин</th><th>Статус</th><th>Сообщений</th><th>Токены</th><th>$ USD</th><th>₽ RUB</th><th>RFM</th><th>Сегмент</th></tr>
${data.users.map(u => `<tr><td>${u.internal_name}</td><td>${u.display_login}</td><td>${u.active ? 'Активен' : 'Отключён'}</td><td>${u.total_messages}</td><td>${u.total_tokens.toLocaleString()}</td><td>$${u.total_cost_usd}</td><td>${u.total_cost_rub} ₽</td><td>${u.rfm.r}${u.rfm.f}${u.rfm.m}</td><td>${u.rfm.segment}</td></tr>`).join('')}
</table>
<h2>Детализация по моделям</h2>
${data.users.filter(u => u.breakdown.length > 0).map(u => `
<h3 style="font-size:12px;margin-top:12px">${u.internal_name} (${u.display_login})</h3>
<table><tr><th>Провайдер</th><th>Модель</th><th>Сообщений</th><th>Входные</th><th>Выходные</th><th>$ USD</th></tr>
${u.breakdown.map(b => `<tr><td>${providerName(b.provider)}</td><td>${b.model}${b.is_video && b.size ? ' · ' + b.size : ''}</td><td>${b.messages}${b.is_video ? ' ген. / ' + (b.seconds || 0) + ' сек' : ''}</td><td>${b.is_video ? '—' : (b.input_tokens||0).toLocaleString()}</td><td>${b.is_video ? '—' : (b.output_tokens||0).toLocaleString()}</td><td>$${b.cost_usd}</td></tr>`).join('')}
</table>`).join('')}
<script>window.onload=function(){window.print()}</script>
</body></html>`;
  win.document.write(html);
  win.document.close();
}

export default function AnalyticsPage({ user }) {
  const isAdmin = user && user.role === 'admin';
  const perms = (user && user.permissions) || {};
  const hasPerm = (p) => isAdmin || !!perms[p];
  const canExport = hasPerm('analytics_export');
  const canViewTokens = hasPerm('view_tokens');
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [expanded, setExpanded] = useState(null);

  const load = useCallback(async () => {
    try {
      const d = await api.statsAnalytics();
      setData(d);
    } catch {}
    setLoading(false);
  }, []);

  useEffect(() => { load(); }, [load]);

  if (loading) return <div style={{ padding: 24, color: 'var(--text2)' }}>Загрузка аналитики...</div>;
  if (!data) return <div style={{ padding: 24, color: 'var(--text2)' }}>Ошибка загрузки данных</div>;

  return (
    <div className="admin-page">
      <div className="admin-header">
        <h2 style={{ margin: 0 }}>Аналитика</h2>
        {canExport && <div style={{ display: 'flex', gap: 8 }}>
          <button className="btn-add" style={{ background: '#217346' }} onClick={() => exportXLS(data)}>📥 Экспорт XLS</button>
          <button className="btn-add" onClick={() => exportPDF(data)}>📄 Экспорт PDF</button>
        </div>}
      </div>

      <div className="stats-grid" style={{ marginBottom: 24 }}>
        <div className="stat-card"><div className="label">Всего сообщений</div><div className="value">{data.totals.messages.toLocaleString()}</div></div>
        {canViewTokens && <div className="stat-card"><div className="label">Входные токены</div><div className="value">{formatTokens(data.totals.input_tokens)}</div></div>}
        {canViewTokens && <div className="stat-card"><div className="label">Выходные токены</div><div className="value">{formatTokens(data.totals.output_tokens)}</div></div>}
        <div className="stat-card"><div className="label">Изображений</div><div className="value">{data.totals.images}</div></div>
        <div className="stat-card"><div className="label">Видео</div><div className="value">{data.totals.videos || 0}</div></div>
        {canViewTokens && <div className="stat-card"><div className="label">Стоимость ($)</div><div className="value">${data.totals.cost_usd}</div></div>}
        {canViewTokens && <div className="stat-card"><div className="label">Стоимость (₽)</div><div className="value">{data.totals.cost_rub} ₽</div></div>}
      </div>

      <h3 style={{ marginBottom: 12, color: 'var(--text2)' }}>RFM-анализ сотрудников <span style={{ fontSize: '0.7rem', fontWeight: 400 }}>(R=Давность, F=Частота, M=Объём)</span></h3>

      <table className="users-table">
        <thead>
          <tr>
            <th>Сотрудник</th>
            <th>Статус</th>
            <th>Сообщ.</th>
            <th>Время</th>
            {canViewTokens && <th>Токены</th>}
            {canViewTokens && <th>$ USD</th>}
            {canViewTokens && <th>₽ RUB</th>}
            <th style={{ textAlign: 'center' }}>R</th>
            <th style={{ textAlign: 'center' }}>F</th>
            <th style={{ textAlign: 'center' }}>M</th>
            <th>Сегмент</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          {data.users.map(u => (
            <React.Fragment key={u.id}>
              <tr style={{ cursor: 'pointer' }} onClick={() => setExpanded(expanded === u.id ? null : u.id)}>
                <td>
                  <div style={{ fontWeight: 600 }}>{u.internal_name}</div>
                  <div style={{ fontSize: '0.75rem', color: 'var(--text2)' }}>{u.display_login}</div>
                </td>
                <td><span className={`badge ${u.active ? 'active' : 'inactive'}`}>{u.active ? 'Активен' : 'Отключён'}</span></td>
                <td>{u.total_messages.toLocaleString()}</td>
                <td>{formatDuration(u.total_session_sec)}</td>
                {canViewTokens && <td>{formatTokens(u.total_tokens)}</td>}
                {canViewTokens && <td>${u.total_cost_usd}</td>}
                {canViewTokens && <td>{u.total_cost_rub} ₽</td>}
                <td style={{ textAlign: 'center', fontWeight: 700, color: rfmColor(u.rfm.r) }}>{u.rfm.r}</td>
                <td style={{ textAlign: 'center', fontWeight: 700, color: rfmColor(u.rfm.f) }}>{u.rfm.f}</td>
                <td style={{ textAlign: 'center', fontWeight: 700, color: rfmColor(u.rfm.m) }}>{u.rfm.m}</td>
                <td>{segmentBadge(u.rfm.segment)}</td>
                <td style={{ fontSize: '0.8rem', color: 'var(--text2)' }}>{expanded === u.id ? '▲' : '▼'}</td>
              </tr>
              {expanded === u.id && (
                <tr>
                  <td colSpan={canViewTokens ? 12 : 9} style={{ background: 'var(--bg3)', padding: 16 }}>
                    <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: 12, marginBottom: 12 }}>
                      <div><span style={{ color: 'var(--text2)', fontSize: '0.8rem' }}>Дней без активности:</span> <strong>{u.rfm.days_since_last === 999 ? '—' : u.rfm.days_since_last}</strong></div>
                      <div><span style={{ color: 'var(--text2)', fontSize: '0.8rem' }}>Активных дней:</span> <strong>{u.rfm.active_days}</strong></div>
                      <div><span style={{ color: 'var(--text2)', fontSize: '0.8rem' }}>Изображений:</span> <strong>{u.image_count}</strong> (~${u.image_cost_usd} / {(u.image_cost_usd * 90).toFixed(2)} ₽)</div>
                      <div><span style={{ color: 'var(--text2)', fontSize: '0.8rem' }}>Видео:</span> <strong>{u.video_count || 0}</strong> ({u.video_seconds || 0} сек, ${u.video_cost_usd || 0} / {((u.video_cost_usd || 0) * 90).toFixed(2)} ₽)</div>
                    </div>
                    {u.breakdown.length > 0 ? (
                      <table className="users-table" style={{ margin: 0 }}>
                        <thead><tr><th>Провайдер</th><th>Модель</th><th>Сообщений</th><th>Входные</th><th>Выходные</th><th>$ USD</th><th>₽ RUB</th><th>Первое</th><th>Последнее</th></tr></thead>
                        <tbody>
                          {u.breakdown.map((b, i) => (
                            <tr key={i}>
                              <td><span className={`badge ${b.provider === 'anthropic' ? 'admin' : 'manager'}`}>{providerName(b.provider)}</span></td>
                              <td style={{ fontSize: '0.85rem' }}>{b.model}{b.is_video && b.size ? ` · ${b.size}` : ''}</td>
                              <td>{b.messages}{b.is_image ? ' ген.' : b.is_video ? ` ген. / ${b.seconds || 0} сек` : ''}</td>
                              <td>{b.is_image || b.is_video ? '—' : formatTokens(b.input_tokens)}</td>
                              <td>{b.is_image || b.is_video ? '—' : formatTokens(b.output_tokens)}</td>
                              <td style={{ color: 'var(--accent2)' }}>${b.cost_usd}</td>
                              <td style={{ color: 'var(--text2)' }}>{(b.cost_usd * 90).toFixed(2)} ₽</td>
                              <td style={{ fontSize: '0.8rem', color: 'var(--text2)' }}>{b.first_use ? b.first_use.slice(0, 10) : '—'}</td>
                              <td style={{ fontSize: '0.8rem', color: 'var(--text2)' }}>{b.last_use ? b.last_use.slice(0, 10) : '—'}</td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    ) : <div style={{ color: 'var(--text2)' }}>Нет данных об использовании AI</div>}
                    {u.image_count > 0 && (
                      <div style={{ marginTop: 12, padding: 12, background: 'var(--bg2)', borderRadius: 6, border: '1px solid var(--border)' }}>
                        <strong style={{ fontSize: '0.8rem', color: 'var(--text2)' }}>Генерация изображений:</strong>
                        <div style={{ display: 'flex', gap: 16, marginTop: 6, fontSize: '0.85rem' }}>
                          <span>Всего: <strong>{u.image_count}</strong></span>
                          <span>Стоимость: <strong style={{ color: 'var(--accent2)' }}>${u.image_cost_usd}</strong></span>
                          <span><strong>{(u.image_cost_usd * 90).toFixed(2)} ₽</strong></span>
                          {u.images_by_model && u.images_by_model.map((im, i) => (
                            <span key={i}>Модель {im.model}: <strong>{im.cnt}</strong></span>
                          ))}
                        </div>
                      </div>
                    )}
                    {u.video_count > 0 && (
                      <div style={{ marginTop: 12, padding: 12, background: 'var(--bg2)', borderRadius: 6, border: '1px solid var(--border)' }}>
                        <strong style={{ fontSize: '0.8rem', color: 'var(--text2)' }}>Генерация видео (Sora):</strong>
                        <div style={{ display: 'flex', gap: 16, marginTop: 6, fontSize: '0.85rem', flexWrap: 'wrap' }}>
                          <span>Всего: <strong>{u.video_count}</strong></span>
                          <span>Секунд: <strong>{u.video_seconds || 0}</strong></span>
                          <span>Стоимость: <strong style={{ color: 'var(--accent2)' }}>${u.video_cost_usd}</strong></span>
                          <span><strong>{((u.video_cost_usd || 0) * 90).toFixed(2)} ₽</strong></span>
                          {u.videos_by_model && u.videos_by_model.map((v, i) => (
                            <span key={i}>{v.model} {v.size}: <strong>{v.cnt}</strong> ({v.secs || 0} сек)</span>
                          ))}
                        </div>
                      </div>
                    )}
                    {u.training_usage?.length > 0 && (
                      <div style={{ marginTop: 12, padding: 12, background: 'var(--bg2)', borderRadius: 6, border: '1px solid var(--border)' }}>
                        <strong style={{ fontSize: '0.8rem', color: 'var(--warning)' }}>Обучение ИИ:</strong>
                        <div style={{ display: 'flex', gap: 16, marginTop: 6, fontSize: '0.85rem', flexWrap: 'wrap' }}>
                          {u.training_usage.map((t, i) => (
                            <span key={i}>{t.model}: <strong>{t.cnt}</strong> запр., {formatTokens((t.input_tokens||0)+(t.output_tokens||0))} tok</span>
                          ))}
                          <span>Стоимость: <strong style={{ color: 'var(--accent2)' }}>${u.training_cost_usd}</strong></span>
                          <span><strong>{(u.training_cost_usd * 90).toFixed(2)} ₽</strong></span>
                        </div>
                      </div>
                    )}
                    {u.estimate_usage?.length > 0 && (
                      <div style={{ marginTop: 12, padding: 12, background: 'var(--bg2)', borderRadius: 6, border: '1px solid var(--border)' }}>
                        <strong style={{ fontSize: '0.8rem', color: 'var(--accent)' }}>Распознавание в сметах:</strong>
                        <div style={{ display: 'flex', gap: 16, marginTop: 6, fontSize: '0.85rem', flexWrap: 'wrap' }}>
                          {u.estimate_usage.map((e, i) => (
                            <span key={i}>{e.model}: <strong>{e.cnt}</strong> запр., {formatTokens((e.input_tokens||0)+(e.output_tokens||0))} tok</span>
                          ))}
                          <span>Стоимость: <strong style={{ color: 'var(--accent2)' }}>${u.estimate_cost_usd}</strong></span>
                          <span><strong>{(u.estimate_cost_usd * 90).toFixed(2)} ₽</strong></span>
                        </div>
                      </div>
                    )}
                  </td>
                </tr>
              )}
            </React.Fragment>
          ))}
        </tbody>
      </table>
    </div>
  );
}
